module.exports = __webpack_public_path__ + "img/4_Is there any hope Paulina Macheiner.6a39a395.jpg";